module.exports = __webpack_public_path__ + "img/banner_industry_2.77e7ae07.png";